import { ExternalVendorIcons } from 'components/ExternalVendorIcons/ExternalVendorIcons'
import { colors } from 'settings/colors'
import type { TPoint } from 'stores/fieldAssetStore/helperTypes'
import { getExternalVendorIconItems } from 'utils/getExternalVendorIconItems'

type BlockWithWeatherStationLabelProps = {
  label: string
  weatherStationLabel: string | null
  weatherStationExternalVendorNames?: TPoint['externalVendorNames']
}

export const BlockWithWeatherStationLabel = ({
  label,
  weatherStationLabel,
  weatherStationExternalVendorNames = [],
}: BlockWithWeatherStationLabelProps) => {
  const weatherStation = (
    <span style={{ color: colors.grey500, fontSize: 'small' }}>{weatherStationLabel}</span>
  )

  return (
    <div>
      {label}
      <br />
      {getExternalVendorIconItems(weatherStationExternalVendorNames).length ? (
        <span css={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
          {weatherStation}
          <ExternalVendorIcons externalVendorNames={weatherStationExternalVendorNames} size={16} />
        </span>
      ) : (
        weatherStation
      )}
    </div>
  )
}
